export const REPORT_INFESTATION = [
  'Low',
  'Moderate',
  'High',
  'Critical',
] as const
export const REPORT_URGENCY = ['Low', 'Medium', 'High', 'Emergency'] as const
export const REPORT_METHODS = [
  'Baiting',
  'Trapping',
  'Spraying',
  'Fumigation',
  'Exclusion',
] as const
export const REPORT_AFFECTED_AREAS = [
  'Kitchen',
  'Bathroom',
  'Basement',
  'Attic',
  'Garden',
  'Garage',
] as const
// Treated areas are a distinct, intervention-specific set (bed-bug oriented in
// the Figma) — not the same list as the observation "affected areas".
export const REPORT_TREATED_AREAS = [
  'Room',
  'Mattress',
  'Furniture',
  'Floor',
  'Outlets',
  'Bed Frame',
  'Other',
] as const
export const REPORT_SIGNS = [
  'Droppings',
  'Gnaw marks',
  'Nests',
  'Tracks',
  'Live sighting',
  'Dead specimens',
] as const
// Product type options for the "Products used" table dropdown.
export const REPORT_PRODUCT_TYPES = [
  'Liquid Insecticide',
  'Gel Bait',
  'Powder',
  'Aerosol',
  'Granular Bait',
  'Dust',
] as const
export const REPORT_RECOMMENDATIONS = [
  'Seal identified wall cracks near the kitchen area',
  'Remove cardboard boxes from storage area',
  'Improve waste management procedures',
  'Fix water leakage under the sink',
  'Increase cleaning frequency in food preparation areas',
  'Replace damaged window screens',
  'Keep exterior doors closed when not in use',
  'Conduct monthly pest monitoring',
  'Educate staff on pest prevention practices',
  'Schedule quarterly preventive treatments',
] as const
export const REPORT_TIME_SPENT = [
  '30 min',
  '1 hr',
  '1.5 hr',
  '2 hr',
  '2.5 hr',
  '3 hr',
] as const
export const REPORT_QUOTE_SUBJECTS = [
  'Additional treatment',
  'Equipment installation',
  'Extended contract',
  'Structural repair',
  'Follow-up service',
] as const
export const MAX_REPORT_PHOTOS = 15
